import { action } from 'typesafe-actions';
import { HttpRequest } from 'types/rest/analyticsTypes';
import {
  SELECT_HTTP_CALLS_DETAIL_TAB,
  SELECT_HTTP_CALLS_VIEW_TRIGGER,
  SET_HTTP_CALLS_ACTIVE_PAGE,
  SET_HTTP_CALLS_PAGE_SIZE,
  SET_HTTP_CALLS_SEARCH_KEYWORD,
} from './httpCallsActionTypes';
import { HTTP_CALL_SET_IS_LOADING_DETAIL } from '../../../data/analyticsDataActionTypes';
import { DetailTabType } from '../../analyticsUiTypes';
import MixpanelService from '../../../../../utils/mixpanelService';
import { SELECTED_HTTP_CALLS_DETAIL_TAB } from '../../../../../utils/mixpanelEvents';

/**
 * Select request in inspection view.
 * @param pageSize
 */
export const selectHttpCallsViewTriggered = (httpCall: HttpRequest) => action(SELECT_HTTP_CALLS_VIEW_TRIGGER, httpCall);

/**
 * Change active page in the http calls view.
 * @param tab
 */
export const changeHttpCallsViewActivePage = (activePage: number) => action(SET_HTTP_CALLS_ACTIVE_PAGE, activePage);

/**
 * Update page size in http calls view.
 * @param pageSize
 */
export const changeHttpCallsViewPageSize = (pageSize: number) => action(SET_HTTP_CALLS_PAGE_SIZE, pageSize);

/**
 * Change search keyword in http calls view.
 * @param pageSize
 */
export const setHttpCallsViewSearchKeyword = (searchKeyword: string) =>
  action(SET_HTTP_CALLS_SEARCH_KEYWORD, searchKeyword);

/**
 * Sets "IsLoading" http call in details section.
 * @param isLoading
 */
export const setLoadingHttpCallDetail = (isLoading: boolean) => action(HTTP_CALL_SET_IS_LOADING_DETAIL, isLoading);

/**
 * Select tab in httpCalls detail view
 * @param pageSize
 */
export const selectHttpCallsDetailTab = (tabName: DetailTabType) => {
  MixpanelService.track(SELECTED_HTTP_CALLS_DETAIL_TAB(tabName));
  return action(SELECT_HTTP_CALLS_DETAIL_TAB, tabName);
};
